/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Kanban_Locked_ConfirmInputs */



/**
* | output |
* | --- |
* | "Continue in Read-Only Mode" |
*
* @param {Explorer_Kanban_Locked_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_kanban_locked_confirm = /** @type {((inputs?: Explorer_Kanban_Locked_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Kanban_Locked_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Continuer en mode lecture seule")
	if (locale === "de") return /** @type {LocalizedString} */ ("Im Nur-Lese-Modus fortfahren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Continua in modalità di sola lettura")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Продолжить в режиме только для чтения")
	if (locale === "es") return /** @type {LocalizedString} */ ("Continuar en modo de solo lectura")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("继续以只读模式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("読み取り専用モードで続行")
	if (locale === "hi") return /** @type {LocalizedString} */ ("केवल पढ़ने के मोड में जारी रखें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Continuar no modo somente leitura")
	return /** @type {LocalizedString} */ ("Continue in Read-Only Mode")
});